import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

const EmailOutlined = (props) => (
  <Svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="M18.72 4H5.12C3.31 4 1.84 5.47 1.84 7.28v9.44c0 1.81 1.47 3.28 3.28 3.28h13.6c1.81 0 3.28-1.47 3.28-3.28V7.28C22 5.47 20.53 4 18.72 4Zm0 1.6c.08 0 .15.01.23.02l-7.02 5.37-6.86-5.38h13.65V5.6Zm1.68 11.12c0 .93-.75 1.68-1.68 1.68H5.12c-.93 0-1.68-.75-1.68-1.68V7.28c0-.28.07-.53.19-.76l7.79 6.12a.81.81 0 0 0 .98.01l7.86-6.01c.08.2.13.42.13.65v9.44l.01-.01Z"
        fill="#FA8E2B"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default EmailOutlined
